import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";
// import { Handle, Position } from 'react-flow-renderer';

import {setWizardPopupItem, setWizardPopupOpened, updateWizardList} from "../wizardActions";
import {WIZARD_POPUP_TYPES} from "../wizardReducer";
import {WIZARD_GROUP_TYPES, wizardGroupInterface, wizardItemInterface} from "../WizardItem/wizardItemInterface";
import UiSwitch from "../../PageLayout/UiSwitch";
import SvgIcons from "../../Icons/SvgIcons";
import {checkForSameSiblingsGroups, getCurrentGroupsFromSource} from "../wizardFunctions";

const WizardNodeActionButtons = (props) => {

  const {wizardActiveItem, wizardGroup, setWizardPopupOpened, updateWizardList, setWizardPopupItem} = props;

  const updateWizardGroup = (property, newValue) => {
    wizardActiveItem.wizardGroups = wizardActiveItem.wizardGroups.map(wizGroup => {
      if (wizGroup.groupName === wizardGroup.groupName) {
        wizardGroup[property] = newValue;
      }
      return wizGroup
    })
    updateWizardList(wizardActiveItem);
  }

  const wizardItemEditClick = (popupType) => {
    setWizardPopupOpened(true, popupType);
    setWizardPopupItem(wizardActiveItem, wizardGroup);
  }

  const hideFeaturesButton = wizardGroup.nodeType !== WIZARD_GROUP_TYPES.group && wizardGroup.nodeType !== WIZARD_GROUP_TYPES.filter;

  const sourceEdge = wizardActiveItem.wizardEdges.find(wizEdge => wizEdge.target === wizardGroup.id);
  const siblingGroups = sourceEdge ? getCurrentGroupsFromSource(sourceEdge.source, wizardActiveItem) : [];
  // console.log("siblingGroups", siblingGroups);
  const areSameSiblingGroups = checkForSameSiblingsGroups(siblingGroups);
  // console.log("areSameSiblingGroups", areSameSiblingGroups);

  return (
    <div className="wizard-group__actions">
      <div className="wizard-group__actions-left">
        <button className="wizard-group__icon ui-icon-gray2"
                onClick={() => wizardItemEditClick(WIZARD_POPUP_TYPES.editGroup)}>
          {SvgIcons.edit}
        </button>
        {hideFeaturesButton || (siblingGroups.length > 1 && !areSameSiblingGroups) ? null : (
          <button className="wizard-group__icon ui-icon-gray2"
                  onClick={() => wizardItemEditClick(wizardGroup.nodeType === WIZARD_GROUP_TYPES.filter
                    ? WIZARD_POPUP_TYPES.filtersExclusion
                    : WIZARD_POPUP_TYPES.featuresExclusion)}>
            {SvgIcons.info}
          </button>
        )}
        {wizardGroup.nodeType === WIZARD_GROUP_TYPES.inputs ? (
          <button className="wizard-group__icon ui-icon-gray2"
                  onClick={() => wizardItemEditClick(WIZARD_POPUP_TYPES.inputsSetup)}>
            {SvgIcons.gear}
          </button>
        ) : null}
      </div>
      <div className="wizard-group__actions-right">
        <UiSwitch onClick={() => updateWizardGroup("enabled", !wizardGroup.enabled)}
                  textId={wizardGroup.enabled ? "checkbox.enabled" : "checkbox.disabled"}
                  checked={wizardGroup.enabled}/>
      </div>
    </div>
  )
};

WizardNodeActionButtons.propTypes = {
  wizardActiveItem: PropTypes.shape(wizardItemInterface).isRequired,
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  updateWizardList,
  setWizardPopupOpened,
  setWizardPopupItem,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardNodeActionButtons)
)
